import { render, staticRenderFns } from "./Scientific_specialty.vue?vue&type=template&id=56dd5fd0&scoped=true"
import script from "./Scientific_specialty.vue?vue&type=script&lang=js"
export * from "./Scientific_specialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd5fd0",
  null
  
)

export default component.exports